import { combineReducers }      from 'redux';
import {reducer as formReducer} from 'redux-form';
import auth                     from './reducer_login';
import turmaReducer             from './reducer_turma';
import usuarioReducer           from './reducer_usuario';
import batalhaReducer           from './reducer_batalha';
import questaoReducer           from './reducer_questao';
import equipeReducer            from './reducer_equipe';
import atividadesReducer        from './reducer_atividades';
import configReducer            from './reducer_config';
import tarefaReducer            from './reducer_tarefas';
import talentosReducer          from './reducer_talentos';
import notificacaoReducer       from './reducer_notificacao';
import scopoReducer             from './reducer_scopo';
import timelineReducer             from './reducer_timeline';

const rootReducer = combineReducers({
   form               : formReducer,
   turmaReducer       : turmaReducer,
   usuarioReducer     : usuarioReducer,
   batalhaReducer     : batalhaReducer,
   questaoReducer     : questaoReducer,
   equipeReducer      : equipeReducer,
   atividadesReducer  : atividadesReducer,
   configReducer      : configReducer,
   tarefaReducer      : tarefaReducer,
   talentosReducer    : talentosReducer,
   notificacaoReducer : notificacaoReducer,
   auth               : auth,
   scopoReducer       : scopoReducer,
   timelineReducer    : timelineReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js